<template>
  <div>
    <div class="position-relative form-input" :class="[ size, { disabled: disabled, focused: focused, filled: value && String(value).length > 0, 'border-danger': errors && errors.length > 0 } ]" @click="editor.view.dom.focus()">
      <div v-if="editor" class="position-sticky p-1 mb-3 rounded-3" style="z-index: 1000; top: 0.5em; backdrop-filter: blur(10px); background-color: rgba(var(--color-secondary), 0.92)">
        <div v-for="(feature, index) in features.filter(item => item.toolbarView)" :key="index" class="d-inline-block">
          <Component :is="feature.toolbarView" :editor="editor" :config="feature.config"/>
        </div>
        <div class="d-inline-block">
          <ButtonView type="shaded" color="foreground" size="small" @click="editor.chain().focus().unsetAllMarks().run()">
            <i class="fas fa-remove-format fa-fw" style="font-size: 1.2em"></i>
          </ButtonView>
        </div>
        <div class="d-inline-block">
          <ButtonView type="shaded" color="foreground" size="small" @click="editor.chain().focus().undo().run()">
            <i class="fas fa-undo-alt fa-fw" style="font-size: 1.2em"></i>
          </ButtonView>
        </div>
        <div class="d-inline-block">
          <ButtonView type="shaded" color="foreground" size="small" @click="editor.chain().focus().redo().run()">
            <i class="fas fa-redo-alt fa-fw" style="font-size: 1.2em"></i>
          </ButtonView>
        </div>
      </div>
      <BubbleMenu v-if="editor" :editor="editor" :should-show="props => features.find(feature => feature.showBubble && feature.showBubble(props)) !== undefined" class="p-1 rounded-3" style="transition: visibility 0.1s ease, opacity 0.1s ease; backdrop-filter: blur(10px); background-color: rgba(var(--color-secondary), 0.92)">
        <div v-for="(feature, index) in features.filter(item => item.showBubble && item.showBubble({ editor: editor, state: editor.state }))" :key="index" class="d-inline-block">
          <Component :is="feature.bubbleView" :editor="editor" :config="feature.config"/>
        </div>
      </BubbleMenu>
      <EditorContent :editor="editor" class="form-input-body"/>
    </div>
    <InputErrorsView :errors="errors"/>
  </div>
</template>

<script>
import { Editor, EditorContent, BubbleMenu } from '@tiptap/vue-3'
import Typography from '@tiptap/extension-typography'
import Document from "@tiptap/extension-document";
import History from "@tiptap/extension-history";
import Dropcursor from "@tiptap/extension-dropcursor";
import Gapcursor from "@tiptap/extension-gapcursor";
import ButtonView from "../general/ButtonView.vue";
import InputErrorsView from "../forms/inputs/InputErrorsView.vue";

export default {
  name: "RichTextInputView",
  components: {ButtonView, EditorContent, BubbleMenu, InputErrorsView},
  emits: ["update:value"],
  props: {
    value: {
      type: [Object, String],
      default: ""
    },
    features: Array,
    disabled: Boolean,
    size: {
      type: String,
      default: "medium",
      validator(value) {
        return ["small", "medium", "large"].includes(value);
      }
    },
    errors: Array
  },
  data() {
    return {
      editor: null,
      currentValue: null,
      focused: false
    }
  },
  watch: {
    value(value) {
      if (value !== this.currentValue) {
        const refactored = value ? this.refactorContent(value) : value;
        this.currentValue = refactored;
        this.editor.commands.setContent(refactored, false);
      }
      // if (value == null || value == "" || this.editor.isEmpty) this.editor.commands.setContent(value, false);
      // const isSame = this.editor.getJSON() === value
      // if (isSame) return;
      // this.editor.commands.setContent(this.value, false)
    },
    modal() {
      this.editor.commands.focus();
    }
  },
  mounted() {
    let extensions = [
      Typography,
      History,
      Dropcursor,
      Gapcursor,
      Document
    ];

    this.features.forEach(feature => {
      feature.getExtensions({ slots: this.$slots }).forEach(extension => {
        if (!extensions.includes(extension)) extensions.push(extension);
      });
    });

    this.editor = new Editor({
      extensions: extensions,
      autofocus: true,
      content: this.value,
      onUpdate: () => {
        this.currentValue = this.refactorContent(this.editor.getJSON());
        this.$emit('update:value', this.currentValue);
      },
      onFocus: () => {
        this.focused = true;
      },
      onBlur: () => {
        this.focused = false;
      }
    });
  },
  beforeUnmount() {
    this.editor.destroy();
  },
  methods: {
    refactorContent(content) {
      if (Array.isArray(content)) {
        return content.map(item => this.refactorContent(item));
      } else if (typeof content === "object") {
        if (content.content) {
          return { ...content, content: this.refactorContent(content.content) };
        } else {
          if (content.marks) {
            return {
              ...content,
              marks: content.marks.map(mark => {
                if (mark.type === "textStyle" && mark.attrs?.color != null) {
                  const match = mark.attrs.color.match(/^rgb\(([0-9]+),\s*([0-9]+),\s*([0-9]+)\)$/i);
                  if (match) {
                    return { ...mark, attrs: { ...mark.attrs, color: "#" + parseInt(match[1]).toString(16).padStart(2, "0") + parseInt(match[2]).toString(16).padStart(2, "0") + parseInt(match[3]).toString(16).padStart(2, "0") }};
                  }
                }
                return mark;
              })
            };
          }
        }
      }
      return content;
    }
  }
}
</script>

<style scoped>
  .ProseMirror, .ProseMirror:focus, .ProseMirror:focus-visible {
    outline: none !important;
  }
  :deep(.ProseMirror, .ProseMirror:focus, .ProseMirror:focus-visible) {
    outline: none !important;
  }
  :deep(:focus-visible) {
    outline: none;
  }
  .ProseMirror:focus-visible {
    outline: none !important;
  }
</style>